import { useState, useEffect } from 'react';

import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import Label, { LabelColor } from '../../../../components/label';

type Props = {
  enrollment: {
    firstName: string;
    lastName: string;
    payerId: string;
    payerName: string;
    enrollmentStatus: string;
    effectiveDate: string;
  }
}


export default function AdminEnrollmentsTableRow({enrollment}: Props) {
  const [statusColor, setStatusColor] = useState<LabelColor>()

  useEffect(() => {
    switch(enrollment.enrollmentStatus){
      case "Enrolled": setStatusColor('success'); break;
      case "Submitted": setStatusColor('warning'); break;
      case "Denied": setStatusColor('error'); break;
      case "Not Submitted": setStatusColor('warning'); break;
      case "Opted Out": setStatusColor('success'); break;
      default: setStatusColor('default');
    }

  }, [enrollment])

  return(
      <TableRow>
        <TableCell>
          {`${enrollment.firstName} ${enrollment.lastName}`}
        </TableCell>
        <TableCell>
          {enrollment.payerId}
        </TableCell>
        <TableCell>
          {enrollment.payerName}
        </TableCell>
        <TableCell>
          <Label color={statusColor}>{enrollment.enrollmentStatus}</Label>
        </TableCell>
        <TableCell>
          {enrollment.effectiveDate}
        </TableCell>
      </TableRow>
  )
}
